module.exports = __webpack_public_path__ + "img/pab.4aa4524a.jpg";